<div class="page-center">
  <p-card class="otp-card text-center" header="OTP Verification">
    <div class="otp-container">
      <h3 class="text-center"></h3>
      <p class="text-center">Enter the 6-digit OTP sent to your email</p>

      <div class="otp-inputs">
        <div
          *ngFor="let digit of otpArray; let i = index"
          class="otp-box"
          [class.active]="i === currentIndex"
          (click)="focusHiddenInput()"
        >
          {{ digit }}
        </div>
        <input
          #hiddenInput
          type="text"
          inputmode="numeric"
          maxlength="6"
          autocomplete="one-time-code"
          class="hidden-input"
          (input)="onOtpChange($event)"
          (keydown)="onKeyDown($event)"
          (paste)="onPaste($event)"
        />
      </div>

      <div class="text-center">
        <button
          class="btn submit m-0"
          [disabled]="resendDisabled"
          (click)="resendOtp()"
        >
          Resend OTP

          <span *ngIf="resendDisabled">({{ timer }}s)</span>
        </button>
      </div>
    </div>
  </p-card>
</div>
